import groupBy from 'lodash.groupby';

import { isArray, isUndefined } from './isDefined';
import Optional from './optional';
import store from '../store/store';

const createProductOptions = data => {
  if (!isArray(data)) {
    return [];
  }

  const lang = store.getState().auth.lang;

  const mappedData = data
    .map(el => {
      return {
        commercialProduct: el.commercialProduct,
        sku: el.translations.sku
      };
    })
    .reduce((arr, el) => {
      if (isUndefined(el.sku)) {
        return arr;
      }

      const translation = Optional(el.sku[lang]).or(el.sku.default);

      return [...arr, { ...el, sku: translation }];
    }, []);

  const grouped = groupBy(mappedData, 'commercialProduct');

  const mappedGrouped = Object.keys(grouped).map(key => {
    const mappedGroupSku = grouped[key].map(el => el.sku);
    const unique = [...new Set(mappedGroupSku)];

    const mapped = unique.map(el => {
      return {
        label: el,
        value: el
      };
    });
    const sorted = mapped.sort((a, b) => {
      if (a.label < b.label) {
        return -1;
      }
      if (a.label > b.label) {
        return 1;
      }
      return 0;
    });

    return {
      label: key,
      options: sorted
    };
  });

  return mappedGrouped;
};

export default createProductOptions;
